var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSent(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    x: "-14.5%",
    y: "-16.1%",
    width: "128.9%",
    height: "132.1%",
    filterUnits: "objectBoundingBox",
    id: "a1wtazotjb"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-38.5%",
    y: "-264.3%",
    width: "177%",
    height: "628.6%",
    filterUnits: "objectBoundingBox",
    id: "qny9g10jnd"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 4,
    in: "SourceAlpha",
    result: "shadowOffsetInner1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "shadowOffsetInner1",
    in2: "SourceAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1,
    result: "shadowInnerInner1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.7 0",
    in: "shadowInnerInner1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "5uy55oco4a",
    d: "M18.333 8.472 0 16.5l2.975-8.25L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.845 8.472h-6.87",
    id: "p4tbd51bbc"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1.141 1.058)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#5uy55oco4a"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#a1wtazotjb)",
    xlinkHref: "#5uy55oco4a"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#5uy55oco4a"
  })), /*#__PURE__*/React.createElement("g", {
    strokeLinecap: "round",
    transform: "translate(1.141 1.058)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#D5DFFE",
    xlinkHref: "#p4tbd51bbc"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#qny9g10jnd)",
    xlinkHref: "#p4tbd51bbc"
  }), /*#__PURE__*/React.createElement("use", {
    stroke: "#111C5B",
    strokeWidth: 1.3,
    xlinkHref: "#p4tbd51bbc"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSent);
export default __webpack_public_path__ + "static/media/sent.c54cda239abaf67f71f377763afdc610.svg";
export { ForwardRef as ReactComponent };